import { UtcTime, ServiceMessageSet, ServiceMessageSetId, OrgId } from 'shared/models';

export const Actions = {
    SVCMSGSETS_REQUEST: 'SVCMSGSETS_REQUEST',
    SVCMSGSETS_SUCCESS: 'SVCMSGSETS_SUCCESS',
    SVCMSGSETS_FAILURE: 'SVCMSGSETS_FAILURE',

    SVCMSGSET_DELETE: 'SVCMSGSET_DELETE',

    SVCMSGSETS_RELOAD: 'SVCMSGSETS_RELOAD',
};

const ONE_DAY = 24 * 60 * 60 * 1000;

export const serviceMessageSetsRequest = (meta?: { nextFetch: UtcTime }) => ({
    type: Actions.SVCMSGSETS_REQUEST,
    meta: meta || {
        nextFetch: Date.now() + ONE_DAY,
    },
});

export const serviceMessageSetsSuccess = (payload: ServiceMessageSet[]) => ({
    type: Actions.SVCMSGSETS_SUCCESS,
    payload,
});

export const serviceMessageSetsFailure = (error: Error) => ({
    type: Actions.SVCMSGSETS_FAILURE,
    payload: error,
    error: true,
});

export const serviceMessageSetDelete = (payload: ServiceMessageSetId) => ({
    type: Actions.SVCMSGSET_DELETE,
    payload,
});

export const serviceMessageSetsReload = () => ({
    type: Actions.SVCMSGSETS_RELOAD,
});
